import { DocsAnalyticsVisitData } from "./SDKDocsAnalyticsVisitData";
export class DocsAnalyticsPageVisitData extends DocsAnalyticsVisitData {
    constructor(model) {
        super(model);
        this.pagePersistentId = model.pagePersistentId;
    }
}
